import { contact } from './index';
// 공통 필터 메서드 적용 
import { checkLimitedUser } from './function/method'

function regProposition(option) {
  return contact.post('proposition.do', option, {
    headers: {
      'Content-Type': 'multipart/form-data',
    }
  }).then((res) => {
    return checkLimitedUser(res)
  })
}

export { regProposition }